import { createTheme, ThemeProvider } from "@mui/material/styles";
import { createContext, useEffect, useState } from "react";
import { Route, Routes } from "react-router-dom";
import "./App.css";
import ArfinBangla from "./pages/bangla_contents/cashbackBangla/ArfinBangla";
import ShareTripBangla from "./pages/bangla_contents/cashbackBangla/ShareTripBangla";
import NagadBangla from "./pages/bangla_contents/discountsBangla/NagadBangla";
import ShareTripTwoBangla from "./pages/bangla_contents/discountsBangla/ShareTripTwoBangla";
import UpayBangla from "./pages/bangla_contents/discountsBangla/UpayBangla";
import FaqBangla from "./pages/bangla_contents/FaqBangla";
import HomeBangla from './pages/bangla_contents/HomeBangla';
import OffersBangla from "./pages/bangla_contents/OffersBangla";
import PrivacyPolicyBangla from "./pages/bangla_contents/PrivacyPolicyBangla";
import TermsConditionBangla from "./pages/bangla_contents/TermsConditionBangla";
import Arfin from "./pages/cashback/Arfin";
import ShareTrip from "./pages/cashback/ShareTrip";
import Nagad from "./pages/discounts/Nagad";
import ShareTripTwo from "./pages/discounts/ShareTripTwo";
import Upay from "./pages/discounts/Upay";
import Faq from "./pages/Faq";
import Home from "./pages/Home";
import Offers from "./pages/Offers";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TncForPartnerReg from "./pages/TncForPartnerReg";
import TermsCondition from "./pages/TermsCondition";


import CashbackBdt100 from "./pages/cashback/CashbackBdt100";
import ConveFee0 from "./pages/cashback/ConveFee0";
import Saving3 from "./pages/cashback/Saving3";
import CashbackBdt100Bangla from "./pages/bangla_contents/cashbackBangla/CashbackBdt100Bangla";
import ConveFee0Bangla from "./pages/bangla_contents/cashbackBangla/ConveFee0Bangla";
import Saving3Bangla from "./pages/bangla_contents/cashbackBangla/Saving3Bangla";


const theme = createTheme({
  palette: {
    primary: {
      main: "#1882FF",
    },
    secondary: {
      main: "#fff",
    },
  },
  typography: {
    fontFamily: ["Montserrat", "sans-serif"].join(","),
    body1: {
      fontSize: "1.2rem",
    },
    body2: {
      fontSize: "1.1rem",
    },
    subtitle1: {
      fontSize: "1.1rem",
    },
    h2: {
      fontSize: "2.5rem",
      fontWeight: 500,
    },
    h3: {
      fontSize: "2rem",
    },
    h4: {
      fontSize: "1.5rem",
    },
    h6: {
      fontWeight: 500,
    },
  },
});

export const LanguageSelector = createContext();

function App() {

  const [language, setLanguage] = useState(window.localStorage.getItem('language'));

  useEffect(() => {
    if (language === "" || language === undefined || language === null || language === "null") {
      setLanguage("EN");
    }
  }, [language]);





  return (
    <LanguageSelector.Provider value={[language, setLanguage]}>
      <ThemeProvider theme={theme}>
        <Routes>
          {language === "EN" ?
            <>
              <Route path="/" exact element={<Home />} />
              <Route path="/offers" element={<Offers />} />
              <Route path="/offers/cashback100" element={<CashbackBdt100 />} />
              <Route path="/offers/conveniencefee0" element={<ConveFee0 />} />
              <Route path="/offers/saving3" element={<Saving3 />} />

              <Route path="/offers/shareTrip" element={<ShareTrip />} />
              <Route path="/offers/arfin" element={<Arfin />} />
              <Route path="/offers/nagad" element={<Nagad />} />
              <Route path="/offers/upay" element={<Upay />} />
              <Route path="/offers/shareTrip-two" element={<ShareTripTwo />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/tnc-for-partnerreg" element={<TncForPartnerReg />} />
              <Route path="/terms-condition" element={<TermsCondition />} />
              <Route path="/faq" element={<Faq />} />
            </>
            :
            <>
              <Route path="/" exact element={<HomeBangla />} />
              <Route path="/offers" element={<OffersBangla />} />

              <Route path="/offers/cashback100" element={<CashbackBdt100 />} />
              <Route path="/offers/conveniencefee0" element={<ConveFee0 />} />
              <Route path="/offers/saving3" element={<Saving3 />} />

              <Route path="/offers/shareTrip" element={<ShareTripBangla />} />
              <Route path="/offers/arfin" element={<ArfinBangla />} />
              <Route path="/offers/nagad" element={<NagadBangla />} />
              <Route path="/offers/upay" element={<UpayBangla />} />
              <Route path="/offers/shareTrip-two" element={<ShareTripTwoBangla />} />
              <Route path="/privacy-policy" element={<PrivacyPolicyBangla />} />
              <Route path="/terms-condition" element={<TermsConditionBangla />} />
              <Route path="/faq" element={<FaqBangla />} />
            </>
          }
        </Routes>
      </ThemeProvider>
    </LanguageSelector.Provider>
  );
}

export default App;
